module.exports = __webpack_public_path__ + "img/overcoming.9b0cba9.png";